import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { USER_ROLE_ADMIN, USER_ROLE_DRIVER } from 'common/userRoles';

import allowedRoles from 'client/helpers/allowedRoles';

import branch from 'client/core/branch';

@allowedRoles({
  roles: [USER_ROLE_ADMIN, USER_ROLE_DRIVER],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@branch({
  currentDriver: ['drivers', 'current'],
})
class SunSetupDriverRedirectPage extends Component {
  static propTypes = {
    currentDriver: PropTypes.object,
  };

  render() {
    const { currentDriver } = this.props;

    if (currentDriver) {
      return <Redirect to={`/sunsetup/drivers/${currentDriver.id}/orders`} />;
    }

    return <Redirect to="/feed" />;
  }
}

SunSetupDriverRedirectPage.displayName = 'SunSetupDriverRedirectPage';

export default SunSetupDriverRedirectPage;
